import { isEmbarcacaoDimensoesEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoDimensoes,
  EmbarcacaoDimensoesState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const DIMENSOES_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoDimensoes> = {
  select: (ficha) => ficha.dimensoes,
  isEmpty: isEmbarcacaoDimensoesEmpty,
  secao: "as Dimensões Principais",
};

interface UseEmbarcacaoDimensoesResult extends EmbarcacaoDimensoesState {
  reload: () => void;
}

/**
 * Consulta as Dimensões Principais da embarcação pedida. Somente leitura:
 * nenhuma escrita é disparada na abertura nem no fechamento do modal (RN003).
 */
export function useEmbarcacaoDimensoes(id: string): UseEmbarcacaoDimensoesResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, DIMENSOES_QUERY);

  return { ...state, dimensoes: data };
}
